export default ({ app }) => {
  app.router.afterEach(() => {
    if (window && window?.dataLayer) {
      window.dataLayer.push({ event: 'optimize.activate' });
    }
    return false;
  });
};
